import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import Tooltip from "@mui/material/Tooltip";
import { getArmedStatusPresentation } from "./armedStatusPresentation";

const ORANGE = "#FF8400";

/**
 * Icon for the sites list "Armed" column and the site About table.
 *
 * Every status gets a tooltip from `getArmedStatusPresentation`, and the two
 * transitional states get their own glyphs — before SUP-515 ARMING,
 * DISARMING, WARNING and ERROR were all the same orange triangle, so a site
 * that was mid-command was indistinguishable from one with a health problem.
 */
export const createArmedIcon = (
  armedInput: boolean,
  armedStatusInput: string
) => {
  const presentation = getArmedStatusPresentation(armedStatusInput, armedInput);
  const status = presentation.status;

  let icon: JSX.Element;
  if (status === "OK") {
    icon = <CheckCircleIcon color="success" />;
  } else if (status === "ARMED_OUTSIDE_SCHEDULE") {
    icon = <WarningIcon color="success" />;
  } else if (status === "WARNING") {
    icon = <WarningIcon sx={{ color: ORANGE }} />;
  } else if (status === "ERROR") {
    icon = <ErrorIcon color="error" />;
  } else if (status === "ARMING") {
    icon = <AutorenewIcon sx={{ color: ORANGE }} />;
  } else if (status === "DISARMING") {
    icon = <HourglassTopIcon sx={{ color: ORANGE }} />;
  } else if (status === "NOT_RUNNING" && armedInput) {
    icon = <WarningIcon sx={{ color: ORANGE }} />;
  } else if (status === "UNKNOWN") {
    icon = <WarningIcon sx={{ color: "#b4b4b4" }} />;
  } else {
    icon = <CancelIcon color="error" />;
  }

  return (
    <Tooltip title={presentation.description}>
      <span
        data-testid="armed-status-icon"
        data-armed-status={status}
        aria-label={presentation.label}
        style={{ display: "inline-flex", verticalAlign: "middle" }}
      >
        {icon}
      </span>
    </Tooltip>
  );
};
